import { render, staticRenderFns } from "./ModuleSetup.vue?vue&type=template&id=59255c85&"
import script from "./ModuleSetup.vue?vue&type=script&lang=js&"
export * from "./ModuleSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports